import React from "react";

/**
 * Componente que renderiza seu conteudo apenas se o valor nao estiver vazio
 * Usado para esconder campos vazios na visualizacao do cliente
 */
function ConditionalField({ value, children }) {
  // Verifica se o valor esta vazio
  const isEmpty =
    value === undefined ||
    value === null ||
    value === "" ||
    (Array.isArray(value) && value.length === 0);

  if (isEmpty) {
    return null;
  }

  return <>{children}</>;
}

export default ConditionalField;
